import { RAILCARDS_CODES } from "../consts";

export const normalizeSeasonRailcards = (seasonRailcardsResponse = {}) => {
  const { links = {}, result = [] } = seasonRailcardsResponse;
  const railcards = result?.map(railcard => {
    const railcardLinkData = links?.[railcard?.railcardCode] || {};
    return { ...railcard, ...railcardLinkData }
  });

  const hasCustomerRailcard1617Saver = !!railcards?.find(railcard => railcard.code === RAILCARDS_CODES.SAVER_1617);

  return {
    railcards,
    hasCustomerRailcard1617Saver,
  }
}
